import { useState } from "react";
import { Modal } from "react-bootstrap";
import { uploadHCCReport } from "../../services/hccService";
import ErrorfeedbackModal from "./ErrorfeedbackModal";
import FlatPickr from 'react-flatpickr';

function UploadReportModal({ isShow, onHide, setInvalidateList, setCurrentPage }) {
	const [isUploading, setIsUploading] = useState(false);
	const [showErrorModal, setShowErrorModal] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const [errorFile, setErrorFile] = useState(null);
	const [receivedDate, setReceivedDate] = useState('');
	const [receivedDateError, setReceivedDateError] = useState('');

	const closeModal = () => {
		onHide();
		setReceivedDate('');
		setReceivedDateError('');
	};

	const openErrorModal = () => {
		setShowErrorModal(true);
	};
	const closeErrorModal = () => {
		setShowErrorModal(false);
	};

	const handleFileChange = async (event) => {
		try {
			setIsUploading(true);
			const file = event.target.files[0];
			if (!file) return;

			const formData = new FormData();
			formData.append("report", file);
			const res = await uploadHCCReport(formData, receivedDate);
			if (res.success) {
				if (res?.data) {
					const bufferArray = new Uint8Array(res?.data?.data);
					const errorFileBlob = new Blob([bufferArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
					setErrorFile(errorFileBlob);
					window.toastr.error(res?.message || "File validation failed. Please download the file for detailed information.");
					setErrorMessage(res?.message || "File validation failed. Please download the file for detailed information.");
					openErrorModal();
				} else {
					onHide();
				}
				setInvalidateList(prev => !prev);
				setCurrentPage(1);
				window.toastr.success(res?.message || "");
				setReceivedDate('');
			} else {
				window.toastr.error(res?.message || "");
			}
		} catch (error) {
			window.toastr.error(error.message || "Something went wrong");
			console.log(error);
		}
		event.target.value = null;
		setIsUploading(false);
	};

	return (
		<>
			<Modal show={isShow} onHide={closeModal} centered>
				<Modal.Header closeButton>
					<Modal.Title>Upload HCC Records</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div>
						<small className="text-danger"> Please use the provided template to upload the HCC records. If you already have an Excel file, ensure that the column headers match the names specified in the template below.</small>
						<div className="py-4">
							<a href={`/NextCode_HCC_Import_Template.xlsx`} download className="download-template-btn">
								<svg xmlns="http://www.w3.org/2000/svg" width="18" fill="currentColor" viewBox="0 0 16 16">
									<path d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383" />
									<path d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z" />
								</svg>{" "}
								<span>Download Template</span>
							</a>
						</div>
					</div>

					<div className="col-md-6 fv-row mb-4">
						<label htmlFor="receivedDate" className="required fs-6 fw-semibold form-label mb-2 assign-to mt-5">Received Date</label>
						<FlatPickr
							options={{
								dateFormat: 'm/d/Y',
							}}
							onChange={(_, currentdateString) => {
								setReceivedDate(currentdateString);
								setReceivedDateError(currentdateString ? "" : "Required");
							}}
							value={receivedDate}
							className="form-control"
							placeholder="Pick a date"
						/>
						{receivedDateError
							&& <div className="text-danger small"> {receivedDateError} </div>}
					</div>

					<div
						style={{
							textAlign: "center",
							border: "1px dashed #ccc",
							width: "100%",
							padding: "2rem",
							borderRadius: "10px",
							cursor: "pointer",
						}}
						onClick={() => {
							if (!receivedDate) {
								setReceivedDateError("Required");
							} else {
								document.getElementById("file").click();
							}
						}}>
						<i className="bi bi-upload" /> Click to upload excel file {isUploading && <span className="spinner-border spinner-border-sm" />}
						<input accept=".xlsx, .xls, .xlsm, .xltx, .xltm" id="file" name="file" type="file" disabled={!receivedDate} style={{ visibility: "hidden", position: "absolute" }} onChange={(e) => handleFileChange(e)} />
					</div>
				</Modal.Body>
			</Modal>
			{showErrorModal && <ErrorfeedbackModal isShow={showErrorModal} onHide={closeErrorModal} message={errorMessage} setErrorMessage={setErrorMessage} onHideUploadModal={onHide} setErrorFile={setErrorFile} errorFile={errorFile} />}
		</>
	);
}

export default UploadReportModal;
